import { ptBR } from "../../../../date-fns/locale/pt-BR.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ptBR
  }
};